import React, { FC } from 'react';
import styles from './loginButton.module.css';

const DOMAIN_SOURCE_MAP = {
  ohyaconst: 'OYC',
  ohyagroup: 'OYG',
} as const;

const PORT_SOURCE_MAP = {
  '8084': 'OYC',
  '8080': 'OYG',
} as const;

const DEFAULT_SOURCE = 'OYG';
const MEMBER_LOGIN_PROD = 'https://member.ohyagroup.com';
const MEMBER_LOGIN_UAT = 'https://member-uat.ohyagroup.com';

const resolveMemberLogin = (): { baseUrl: string; sourceCode: string } => {
  const { hostname, port } = window.location;

  const domainMatch = (Object.entries(DOMAIN_SOURCE_MAP) as [
    string,
    string
  ][]).find(([domain]) => hostname.includes(domain));
  if (domainMatch) {
    return { baseUrl: MEMBER_LOGIN_PROD, sourceCode: domainMatch[1] };
  }

  if (port && port in PORT_SOURCE_MAP) {
    return {
      baseUrl: MEMBER_LOGIN_UAT,
      sourceCode: PORT_SOURCE_MAP[port as keyof typeof PORT_SOURCE_MAP],
    };
  }

  // 本機開發等無法判斷時，走 UAT + 預設事業體
  return { baseUrl: MEMBER_LOGIN_UAT, sourceCode: DEFAULT_SOURCE };
};

export const LoginButton: FC = () => {
  const { baseUrl, sourceCode } = resolveMemberLogin();
  const loginUrl = `${baseUrl}?source=${sourceCode}`;

  return (
    <a
      className={styles.loginBtn}
      href={loginUrl}
      target={loginUrl.startsWith('http') ? '_blank' : undefined}
      rel={loginUrl.startsWith('http') ? 'noreferrer' : undefined}
    >
      會員登入
    </a>
  );
};
